import { Alert, Checkbox, Tooltip, Typography } from "antd";
import { HelpIcon } from "components/Icons";
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import { toolsName } from "views/GlobalSettings/ToolsName";

const CONFIG_TYPE_MAP = {
  [toolsName.PRISMA_CLOUD_TWISTLOCK]:
    "PRISMA_TWISTLOCK_FETCH_COMPLIANCE_FINDINGS",
  [toolsName.CROWDSTRIKE_FALCON]:
    "CROWDSTRIKE_FALCON_ONLY_FETCH_RUNNING_CONTAINERS_FINDINGS",
};

const info = (
  <Tooltip
    title={
      <>
        If checked, only findings linked to running containers will be ingested.
        Consequently, the mapping screen will only list these containers.
      </>
    }
  >
    <HelpIcon />
  </Tooltip>
);

const CHECKBOX_TEXT_DISPLAY = {
  [toolsName.PRISMA_CLOUD_TWISTLOCK]: `Ingest Compliance Findings From ${toolsName.PRISMA_CLOUD_TWISTLOCK}`,
  [toolsName.CROWDSTRIKE_FALCON]: (
    <>Ingest findings for Running Containers only {info}</>
  ),
};

const TOOLS_WITH_DEFAULT_CHECKED = [toolsName.PRISMA_CLOUD_TWISTLOCK];

const GenericSyncPRsConfig = forwardRef(function GenericSyncPRsConfig(
  { toolName }: { toolName: string },
  ref,
) {
  const [toolSyncPRs, setToolSyncPRs] = useState<boolean>(() =>
    TOOLS_WITH_DEFAULT_CHECKED.includes(toolName),
  );
  useEffect(() => {
    const { promise, cancel } = ToolsIntegrationsAPI.syncToolPRs(
      CONFIG_TYPE_MAP[toolName],
    );
    promise.then(setToolSyncPRs);
    return cancel;
  }, [toolName]);

  const handleToolSyncPRChange = useCallback((e) => {
    setToolSyncPRs(e.target.checked);
  }, []);

  const onSave = useCallback(() => {
    return ToolsIntegrationsAPI.updateToolSyncPRs(
      toolSyncPRs,
      CONFIG_TYPE_MAP[toolName],
    ).promise;
  }, [toolSyncPRs, toolName]);

  useImperativeHandle(ref, () => ({ onSave }));

  return (
    <Alert
      className="p-sm"
      message={
        <Typography.Text strong>
          Configure Ingestion of ArmorCode Findings
        </Typography.Text>
      }
      description={
        <>
          <Checkbox
            checked={toolSyncPRs}
            onChange={handleToolSyncPRChange}
            className="m-r-xs"
          />
          <Typography.Text>
            {CHECKBOX_TEXT_DISPLAY[toolName]
              ? CHECKBOX_TEXT_DISPLAY[toolName]
              : `Ingest ${toolName} Pull Requests`}
          </Typography.Text>
        </>
      }
    />
  );
});

export default GenericSyncPRsConfig;
